import * as React from 'react';
import { styles } from './styles';
import { Layout } from '@graphql/types';
import { themeService } from '@routes/event/guest/services/theme/themeService';
import { Toggle } from '@joykit';

interface Props {
  currentLayout: Layout;
  currentThemeKey: string;
  useSuggestedBackgroundColor: boolean;
  onUseWeddingColorClick: React.MouseEventHandler<HTMLElement>;
}

export const UseWeddingColorSection: React.SFC<Props> = ({
  currentLayout,
  currentThemeKey,
  useSuggestedBackgroundColor,
  onUseWeddingColorClick
}) => {
  const hideWeddingColorSection = currentLayout !== Layout.aloha;
  if (hideWeddingColorSection) {
    return null;
  }

  const enableWeddingColorSection = hideWeddingColorSection
    ? false
    : themeService(currentThemeKey, Layout.aloha).supportsWeddingColor;

  const theme = themeService(currentThemeKey, Layout.aloha);
  return (
    <div>
      {/* <div className={styles.suggestedContainer(theme.color)}>
        <div />
        <span>Suggested Background Color</span>
      </div> */}
      <div className={styles.weddingColorContainer(enableWeddingColorSection)}>
        <div className={styles.themeDefault}>
          <span>
            Use theme's default background <div className={styles.colorDot(theme.color)} />
          </span>
        </div>

        <Toggle
          checked={enableWeddingColorSection ? useSuggestedBackgroundColor : true}
          disabled={!enableWeddingColorSection}
          aria-label={enableWeddingColorSection ? undefined : 'This theme has a set background color'}
          title={enableWeddingColorSection ? undefined : 'This theme has a set background color'}
          onClick={onUseWeddingColorClick}
        />
      </div>
    </div>
  );
};
